import { observer } from 'mobx-react'
import { useContext } from 'react'

import AuthContext from '@contexts/Auth/AuthContext'

import { NotificationButton, NotificationModal } from './components'
import { FIELD_OPERATIONS_ROLE_ID, ACCOUNT_MANAGEMENT_ROLE_ID } from './OperationsNotificationStore'

const _OperationsNotification = () => {
  const { user } = useContext(AuthContext)

  const hasPermission = user?.roles?.some(role => role.id === FIELD_OPERATIONS_ROLE_ID || role.id === ACCOUNT_MANAGEMENT_ROLE_ID)

  if (!hasPermission) return null

  return (
    <>
      <NotificationButton />
      <NotificationModal />
    </>
  )
}

export const OperationsNotification = observer(_OperationsNotification)
